// 📄 data/paises.ts
// Lista de países para el selector de "País de residencia" en Mi Perfil
// (usado para mostrar zona horaria en reuniones y coordinación de equipo).
export const PAISES: string[] = [
  'Alemania',
  'Argentina',
  'Australia',
  'Austria',
  'Bélgica',
  'Bolivia',
  'Brasil',
  'Canadá',
  'Chile',
  'China',
  'Colombia',
  'Corea del Sur',
  'Costa Rica',
  'Cuba',
  'Dinamarca',
  'Ecuador',
  'Egipto',
  'El Salvador',
  'Emiratos Árabes Unidos',
  'España',
  'Estados Unidos',
  'Filipinas',
  'Finlandia',
  'Francia',
  'Grecia',
  'Guatemala',
  'Honduras',
  'Hungría',
  'India',
  'Indonesia',
  'Irlanda',
  'Israel',
  'Italia',
  'Japón',
  'Kenia',
  'Malasia',
  'Marruecos',
  'México',
  'Nicaragua',
  'Nigeria',
  'Noruega',
  'Nueva Zelanda',
  'Panamá',
  'Paraguay',
  'Países Bajos',
  'Perú',
  'Polonia',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reino Unido',
  'República Checa',
  'República Dominicana',
  'Rusia',
  'Singapur',
  'Sudáfrica',
  'Suecia',
  'Suiza',
  'Tailandia',
  'Turquía',
  'Ucrania',
  'Uruguay',
  'Venezuela',
  'Vietnam',
  'Otro'
];
